import $ from 'jquery';
window.jQuery = $;

import './components/nav'
import './pages/home'